@if (changes()) {
  <div mat-dialog-title>
    Historial de Cambios 
  </div>
  
  <div mat-dialog-content class="content">

    <mat-stepper orientation="vertical">
      @for (change of changes().slice().reverse(); track $index) {
        @let changeSet = filterChangeSet(change);
        @if (changeSet.length > 0) {
          <mat-step completed="false">
          <ng-template matStepLabel>
            <span class="title">
              @if ('confirmed' in change.changeset) {
                Cliente
              } @else {
                {{change.name || 'Sistema'}}
              }
            </span>
            <br>
            <span class="subtitle">{{ getVerb(change.item_type, change.changeset) }} <span class="model-name">{{getModelName(change)}}</span></span>
            <br>
            <span class="second-subtitle">{{change.created_at | date:'short'}}</span>
          </ng-template>
          <ng-template matStepContent>
            @if (change.object_changes) {
              <div class="info">
              @for (attr of changeSet; track attr.id) {
                  <div class="name">{{attr.name}}</div>
                  <div class="value">
                    @if (attr.id in REDIRECTABLE_ATTRS) {
                      @if (change.changeset[attr.id][0]) {
                        <span
                            go-to-details
                            [element]="{id: change.changeset[attr.id][0], type: REDIRECTABLE_ATTRS[attr.id]}"
                            class="link"
                        >
                          {{getValue(attr.id,change.changeset[attr.id][0]) || 'Vacío'}}
                        </span>
                        <mat-icon>arrow_forward</mat-icon>
                      }
                      <span
                          go-to-details
                          [element]="{id: change.changeset[attr.id][1], type: REDIRECTABLE_ATTRS[attr.id]}"
                          class="link">
                        {{getValue(attr.id,change.changeset[attr.id][1]) || 'null'}}
                      </span>
                    }
                    @else {
                      @if (change.changeset[attr.id][0]) {
                        <span>{{getValue(attr.id,change.changeset[attr.id][0]) || 'Vacío'}}</span>
                        <mat-icon>arrow_forward</mat-icon>
                      }
                      <span>{{getValue(attr.id,change.changeset[attr.id][1]) || 'null'}}</span>
    
                    }
                  </div>
                }
              </div>
            } @else {
            <span>Sin cambios registrados</span> 
            }
          </ng-template>
          </mat-step>
        }
      }
    </mat-stepper>

    @if (changes() && changes().length == 0) {
    <div>
      <span>No hay cambios</span>
    </div>
    }

  </div>

  
  <div mat-dialog-actions class="footer">
  <button mat-button mat-dialog-close cdkFocusInitial>Cerrar</button>
  </div>
}
@else {
  <mat-spinner></mat-spinner>
}
